import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { isCalizyAccount, isImaSanteAccount, isMgasAccount, isImhAccount, isMatmutAccount, isMmeAccount, isApizeeAccount, isApgisAccount, isMgefiAccount, isHesAccount, isAlmAccount, isPlanifAccount, isMondialAccount, isDafassurAccount, isRadianceAccount, isMnhDirDevAccount, isVyvEsAccount, } from '@/helpers/account';
let AccountMixin = class AccountMixin extends Vue {
    get isImaSanteAccount() {
        return isImaSanteAccount(this.user());
    }
    get isCalizyAccount() {
        return isCalizyAccount(this.user());
    }
    get isMgasAccount() {
        return isMgasAccount(this.user());
    }
    get isImhAccount() {
        return isImhAccount(this.user());
    }
    get isMatmutAccount() {
        return isMatmutAccount(this.user());
    }
    get isMmeAccount() {
        return isMmeAccount(this.user());
    }
    get isApizeeAccount() {
        return isApizeeAccount(this.user());
    }
    get isApgisAccount() {
        return isApgisAccount(this.user());
    }
    get isMgefiAccount() {
        return isMgefiAccount(this.user());
    }
    get isHesAccount() {
        return isHesAccount(this.user());
    }
    get isAlmAccount() {
        return isAlmAccount(this.user());
    }
    get isRadianceAccount() {
        return isRadianceAccount(this.user());
    }
    get isMondialAccount() {
        return isMondialAccount(this.user());
    }
    get isDafassurAccount() {
        return isDafassurAccount(this.user());
    }
    get mainLogo() {
        if (this.isAlmAccount) {
            return this.user().account_name;
        }
        return 'logo';
    }
    get isPlanifAccount() {
        return isPlanifAccount(this.user());
    }
    get isMnhDirDevAccount() {
        return isMnhDirDevAccount(this.user());
    }
    get isVyvEsAccount() {
        return isVyvEsAccount(this.user());
    }
};
AccountMixin = __decorate([
    Component
], AccountMixin);
export default AccountMixin;
;
